module.exports = __webpack_public_path__ + "media/custom/images/img28-dd69f6e6244d1d686e04dc71ff24ff80.png";